module.exports = __webpack_public_path__ + "static/media/17.9717e3f1.jpg";